<template>
  <div class="home_links vue_flex vue_warp">
    <!--         height: item.height + 'px',
        width: item.width + 'px', -->
    <div
      @click="linkboxs(item)"
      class="home_item vue_flex vue_column vue_flex_around"
      v-for="(item, linkIndex) in list"
      :key="linkIndex"
      :style="{
        backgroundImage: 'url(' + item.img + ')',
      }"
    >
      <div class="home_item_t1">{{ item.tit }}</div>
      <div class="home_item_t2">{{ item.num }}</div>
      <p class="vue-font-PingFang-500 color_112">{{ item.bi }}</p>
      <p class="vue-font-PingFang-500 color_112" v-if="item.bihou">
        {{ item.bihou }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    linkboxs(item) {
      console.log("item", item);
      this.$emit("itemClick", item);
    },
  },
};
</script>

<style scoped lang="scss">
.home_links {
  margin-top: 20px;
  // gap: 20px;
  .home_item {
    cursor: pointer;
    width: 19%;
    background-size: 100% 100%;
    padding: 25px;
    margin-right: 1%;
    margin-bottom: 20px;
    .home_item_t1 {
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 19px;
      color: #232323;
    }
    .home_item_t2 {
      font-family: PingFang SC;
      font-weight: 800;
      font-size: 27px;
      color: #232323;
    }
    p {
      font-size: 16px;
      line-height: 16px;
    }
    &:nth-of-type(5n) {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/linkdata/index.vue